import ActionCable from 'actioncable';

export class WSClient {
  static connect() {
    const token = localStorage.getItem('user_token')?.replace('.', '-') || '';
    return ActionCable.createConsumer(`${process.env.REACT_APP_CABLE_URL}/${encodeURI(token)}`);
  }
}